import { formatTimestamp, NOW } from '../util/util'
import { CONSTS,
         INFO,
		 TIMES,
		 RUNS, 
		 STATS} from '../util/object'



///////////////////////////////////////////////////////////////////////////////////
         
// support x & x% input format
//      - INFO.image_width set in analyzeImage()
//
const calcPx = (x0, y0) => {
    var x, y;

    //console.log("calcpx.33:    . . . x0=",x0, " typeof(x0)=",typeof(x0));   //, " x0.end=",x0.slice(-1));
    if (x0 && (typeof(x0) === "string") && (x0.slice(-1) === "%")) {
        x = parseInt(x0.slice(0,-1)) * INFO.image_width / 100;
    } else {
        x = x0
    }
    
    if (y0 && (typeof(y0) === "string") && (y0.slice(-1) === "%")) {
        y = parseInt(y0.slice(0,-1)) * INFO.image_height / 100;
    } else {
        y = y0
    }
    
    return [parseInt(x), parseInt(y)];
}


// display a text label
//
export function displayText(color, size, label, x0, y0) {
	var context = INFO.out_context;
  if (!context) return

  var [x, y] = calcPx(x0, y0);

	context.fontWeight = "normal";
	context.font = size.toString()+"px arial";
	context.fillStyle = color
	context.fillText(label, x, y);		// use fillStyle

	//context.strokeStyle = color
	//context.strokeText(label, x, y);		// NO NEED: use fillStyle (mess up)
}


// display a text label with border
//
export function displayBorderText(color, border, fsize, bsize, label, x0, y0) {
	var context = INFO.out_context;
  if (!context) return

  var [x, y] = calcPx(x0, y0);

    context.fontWeight = "bolder";
	context.font = fsize.toString()+"px arial";
	context.fillStyle = color
	context.fillText(label, x, y);		// use fillStyle

	context.beginPath();       // Start a new path
    context.strokeStyle = border;       //"#666";
    context.lineWidth = bsize;          // need a number
    context.strokeText(label, x0, y0);
	//context.strokeStyle = color
	//context.strokeText(label, x, y);		// NO NEED: use fillStyle (mess up)
}


// display a bounding box
//
export function displayBox(color, width, x0, y0, w, h) {
	var context = INFO.out_context;
  if (!context) return

  var [x, y] = calcPx(x0, y0);
  width = (width === 0) ? 0.1 : width;
	context.beginPath();       // Start a new path
	context.lineWidth = width;
	context.strokeStyle = color
	context.strokeRect(x, y, w, h);
}


// display a solid block
//
export function displayBlock(color, x0, y0, w0, h0) {
	var context = INFO.out_context;
  if (!context) return

  var [x, y] = calcPx(x0, y0);
  var [w, h] = calcPx(w0, h0);

	//context.lineWidth = width;
	context.fillStyle = color
	context.fillRect(x, y, w, h);
}


// display an image
//
export function displayImage(image, alpha, x, y, w, h) {
	var context = INFO.out_context;
  if (!context) return

	context.globalAlpha = alpha;
	context.drawImage(image, x, y, w, h);
}


// display an ellipse
//
export function displayEllipse(color, border, line_width, x0, y0, w, h) {
	var context = INFO.out_context;
  if (!context) return

    var line = line_width;
    if (line_width === 0) {
        line = 0.1;
        border = color;
    }
    var [x, y] = calcPx(x0, y0);

	context.lineWidth = line;     // Note: can not be ZERO?
	context.strokeStyle = border;
	context.beginPath();       // Start a new path
	context.ellipse(x, y, w, h, 0, 0, Math.PI*2);
	context.stroke();     // this has prob

	context.fillStyle = color;
	context.fill();

}


// tut: https://riptutorial.com/html5-canvas/example/15185/stroke--a-path-command-
export function displayLine(x0, x1, y0, y1, color, width) {
	var context = INFO.out_context;
  if (!context) return

    width = (width === 0) ? 0.1 : width;
	context.lineWidth = width;
	context.strokeStyle = color;
	context.beginPath();
	context.moveTo(x0, y0);
	context.lineTo(x1, y1);		 //context.quadraticCurveTo(x0, y0, x1, y1);
	//context.closePath();
	context.stroke();
}


/////////////////////////////////////////////////////////////////////////////////////////////////////////////




// show a center dot
//
export function displayCenterDot(color, width, x, y) {
	var context = INFO.out_context;
  if (!context) return

    width = (width === 0) ? 0.1 : width;

	context.strokeStyle = color;
	context.lineWidth = width;
	context.strokeRect(x, y, 2, 2);
}




// add micro timestamp for each frame
//
export function displayFrameTimestamp(t0) {
	//var canvas = document.getElementById(INFO.analysis_canvas);
	//var ctx1 = canvas.getContext("2d");
	var canvas = INFO.out_canvas;
	var ctx1 = INFO.out_context;
  if (!canvas) return


	var show_timestamp = true;
	if((canvas == null) || (show_timestamp == false))
		return;

	var width = canvas.width;
	var height = canvas.height;
    var color = "red";      // if we have started session timing
	var timestamp = formatTimestamp(t0 - TIMES.start_run, 1);

    if (INFO.dev_analyze_mode === true) {
        timestamp = formatTimestamp(t0 - TIMES.start_run, 2);
        color = "white";        // pre-timing color
    } else if (INFO.perf_running === false) {
        timestamp = formatTimestamp(t0 - TIMES.webcam_start, 3);
        color = "white";        // pre-timing color
    }

    var output = timestamp;
    if (INFO.current_fps > 0) {
        output = timestamp + "   "+INFO.current_fps.toFixed(1) + "FPS";
    }

	//var font_size = (width + height) / 38;
    var x = 5 * INFO.scale_x;
    var y = 12 * INFO.scale_y;
	var fsize = ((360 + 270) / 50) * INFO.scale_font;
    if (INFO.webcam_owidth === 1280) {
        x = 10;
        y = 60;
        fsize = 65;
    }
	ctx1.font = (fsize).toString()+"px arial";
	ctx1.fontWeight = "700";
	ctx1.fillStyle = color;
	ctx1.fillText(output, x, y);
	//ctx1.fillText(output, (5 * INFO.scale_x), (height * 0.05 * INFO.scale_y));
	//console.log("vid.165:  time=",timestamp, " y=", Math.floor(height*0.05), "  font_size=", font_size);
}


export function displayStars(stars, Star_shape) {
	var canvas = INFO.out_canvas;
  if (!canvas) return

	var width = canvas.width;
	var height = canvas.height;
    var x = width * 0.70;
    var y = 14 * INFO.scale_y;
    var size = 30 * INFO.scale_x;
    var gap = 0 * INFO.scale_x;

    for (var i = 0; i < stars; i++) {
        displayImage(Star_shape, 1, x+ ((size+gap) * i), y, size, size);
    }
}



// DEV TOOL
//    - Dev: show the detected motion vectors in sync with video
//    - use this to figure out the signal sequence to detect a turn (using k-nn)
//
export function displayMotionMarkers(hidx, markers) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
  if (!canvas) return

	var width = canvas.width;
	var height = canvas.height;
    var scale = height / 270;
    var LNAME = CONSTS.LIMBS_NAME;
    var MNAME = CONSTS.MEMBS_NAME;
    var limb;

    //console.log("draw.202:    MOTION MARKERS    canvas=",canvas,  "  markers=",markers);
	if (canvas == null) { return; }

    var x = width * 1 / 2;
    var y = height / 20;
    var wd = 180 * scale;
    var ht = 4 * 13 * scale;

    displayBlock("#ffffff50", (x - 5), (y - 15), wd, ht);
    var idx = 0;
    for (var i in markers) {
        var marker = markers[i];
        var step = idx * 12 * scale;
        limb = LNAME[marker.limb];

        // display only if it's enabled
        //
        var field = limb+"_state";
        if(INFO[field] === true) {
            var msg = hidx+": "+marker.tokn+"     "+LNAME[marker.limb]+" " +MNAME[marker.memb]+ " " + marker.amx1 + " " + marker.adl1 +" " + marker.amx2 + " " + marker.adl2 + " " + marker.tdel;

            context.fillStyle = 'red';		// for fillText()
            context.font = ((width + height)/85).toString()+"px arial";
            context.fillText(msg, x, y + step);
            idx = idx + 1;
        } else {
            //console.log("draw.223:    - - - -  SKIP MOTION MARKER    limb=",limb);
        }
        //console.log("draw.230:    - - - -  SHOW MOTION MARKER    limb=",limb, " state=",INFO[limb+"_state"]);
    }
}


// average the two signals, if they are valid
//
const VALID_THRESH = 60;
function smartAverageLength(sig1, sig2) {
   var sum = 0, cnt = 0;

   if(sig1.score > VALID_THRESH) {
       sum = sig1.len;
       cnt = 1;
   }

   if(sig2.score > VALID_THRESH) {
       sum = sum + sig1.len;
       cnt = cnt + 1;
   }

   var avg = sum / cnt;
   return avg;
}



// DEV TOOL
//    - Dev debug to show pose head and foot position details
//    - diplay various limb ratios to detect camera angle
//    - diplay various limb ratios to detect camera angle
//    
//
export function displayBodyRatio(hidx, sigs, dtop, dbot) {
	var canvas = INFO.out_canvas;
  if (!canvas) return

	var context = INFO.out_context;
	var width = canvas.width;
	var height = canvas.height;
    var scale = height / 270;
    var LNAME = CONSTS.LIMBS_NAME;
    var MNAME = CONSTS.MEMBS_NAME;
	if (canvas == null) { return; }

    var x = width * 1 / 4;
    var y = height / 20;
    var wd = 90 * scale;
    var ht = 6 * 13 * scale;

    displayBlock("#ffffff50", (x - 5), (y - 15), wd, ht);

    var femur = smartAverageLength(sigs.lthg, sigs.rthg);
    var leg2 = smartAverageLength(sigs.lleg, sigs.rleg);
    var leg = femur + leg2;
    var ched = sigs.ched.len;
    var torsol = sigs.cbod.len;
    var tall = ched + torsol+ + leg;

    var leg_pct = parseInt(leg * 100 / femur);
    var hed_pct = parseInt(ched * 100 / femur);
    var bod_pct = parseInt(torsol * 100 / femur);
    var tal_pct = parseInt(tall * 100 / femur);
    var ratio = (dbot > 0) ? (dtop / dbot).toFixed(3) : 0;

    var msgs = [];
    msgs[0]= "FEMR "+": "+(femur).toFixed(3)+"     ";
    msgs[1]= "LEGS "+": "+(leg).toFixed(3)+"     "+leg_pct.toFixed(0);
    msgs[2]= "CHED "+": "+(ched).toFixed(3)+"     "+hed_pct.toFixed(0);
    msgs[3]= "TALL   "+": "+(tall).toFixed(3)+"     "+tal_pct.toFixed(0);
    msgs[4]= "DORS "+": dtp="+dtop+"  dbt="+dbot+" ratio="+ratio;

    var idx = 0;
    for (var i in msgs) {
        var msg = msgs[i];
        var step = idx * 12 * scale;

        context.fillStyle = 'blue';		// for fillText()
        context.font = ((width + height)/85).toString()+"px arial";
        context.fillText(msg, x, y + step);
        idx = idx + 1;
        //console.log("draw.230:    - - - -  SHOW MOTION MARKER    limb=",limb, " state=",INFO[limb+"_state"]);
    }

}


// DEBUG
//    - visual aid to see the limb movements
//    - handle in pairs, detect [larm, rarm, lthg, rthg], draw the 4 couples
//    - use "member.angle" to get <x, y>
//
const S = {     // limb starting coord
    box_x: 10, box_y: 75,
    box_w: 80, box_h: 90,
    larm_x: 70, larm_y: 110,
    rarm_x: 40, rarm_y: 110,
    lthg_x: 70, lthg_y: 130,
    rthg_x: 40, rthg_y: 130,
    ched_x: 55, ched_y: 100,
}
const C = {     // limb couple member
    larm: "lfam",
    rarm: "rfam",
    lthg: "lleg",
    rthg: "rleg",
    ched: "ched",
}

// UTIL
//   - show limb couple on the side to help develop model (single step)
//
const CONFIDENCE = 65;
export function displayMotionSkeleton(trail3d, signal) {

    var [larm_a0, larm_c0, larm_a1, larm_c1, larm_s] = get3DLimbInfo(trail3d, signal, "larm");
    var [rarm_a0, rarm_c0, rarm_a1, rarm_c1, rarm_s] = get3DLimbInfo(trail3d, signal, "rarm");
    var [lthg_a0, lthg_c0, lthg_a1, lthg_c1, lthg_s] = get3DLimbInfo(trail3d, signal, "lthg");
    var [rthg_a0, rthg_c0, rthg_a1, rthg_c1, rthg_s] = get3DLimbInfo(trail3d, signal, "rthg");
    var [ched_a0, ched_c0, ched_a1, ched_c1, ched_s] = get3DLimbInfo(trail3d, signal, "ched");

    displayBlock("#ffffff50", S.box_x, S.box_y, S.box_w, S.box_h);
    if(larm_s > CONFIDENCE) displayLimb("UL", S.larm_x, S.larm_y, larm_a0, larm_c0, larm_a1, larm_c1);
    if(rarm_s > CONFIDENCE) displayLimb("UR", S.rarm_x, S.rarm_y, rarm_a0, rarm_c0, rarm_a1, rarm_c1);
    if(lthg_s > CONFIDENCE) displayLimb("BL", S.lthg_x, S.lthg_y, lthg_a0, lthg_c0, lthg_a1, lthg_c1);
    if(rthg_s > CONFIDENCE) displayLimb("BR", S.rthg_x, S.rthg_y, rthg_a0, rthg_c0, rthg_a1, rthg_c1);
    if(ched_s > CONFIDENCE) displayLimb("CH", S.ched_x, S.ched_y, ched_a0, ched_c0, ched_a1, ched_c1);
}


// UTIL
//    - get the field angles from the trail3d
//

export function get3DLimbInfo(trail3d, signal, field0) {

    var field1 = C[field0];     // find the lower memeber couple
    //console.log("3d_limb.257:   = = = = = = = signal=",signal, "  trail3d=",trail3d, " field0=",field0, " field1=", field1);

    var c0 = signal[field0].degree;
    var c1 = signal[field1].degree;
    var a0 = c0 - trail3d["a"+field0];
    var a1 = c1 - trail3d["a"+field1];
    var s0 = signal[field0].score
	var s0 = Math.floor((signal[field0].score + signal[field1].score)/2);

    //console.log("3d_limb.266:        . . . .  ",field0, "  a0",a0, " c0=",c0, "  a1=",a1, " c1=",c1, " s0=",s0);
    return [a0, c0, a1, c1, s0];
}



// UTIL
//    - diplay limb couple
//    - convert angle into (x, y) and plot it
//
export function displayLimb(limb, sx0, sy0, sa0, ca0, sa1, ca1) {
    var shift1 = null, shift2 = null, sign = 1;
    var radius = 14;

    var color1 = "#cc0000c0";
    var color2 = "#ff000040";
    var color3 = "#0000ccc0";
    var color4 = "#0000ff40";
    var width1 = 2;
    var width2 = 1;
    var show2 = true;
    switch(limb) {
        case "CH":
            show2 = false;
            radius = 8;
            shift1 = -90;
            sa0 = -sa0;
            ca0 = -ca0;
            color1 = "#c40af9c0"; 
            color2 = "#c40af950";
            width1 = 4;
            width2 = 3;
            break;
        case "UL":
        case "UR":
            shift1 = 90;
            shift2 = 90;
            //sign = (sa0 > 90) ? 1 : -1;       // 2nd bends up
            sign = 1;       // 2nd bends up
            break;
        case "BL":
        case "BR":
            shift1 = 90;
            shift2 = 90;
            sign = -1;      // 2nd bend down
            break;
    }

    // Radian: degree * PI / 180
    // Math.cos/sin need degrees in radians :/
    //var ax0 = radius * (1 + Math.cos((sa0 - 180) * Math.PI / 180));
    //var ay0 = radius * (1 + Math.sin((sa0 - 180) * Math.PI / 180));
    var ax0 = radius * Math.cos((sa0+shift1) * Math.PI / 180);
    var ay0 = radius * Math.sin((sa0+shift1) * Math.PI / 180);
    var x1 = sx0 + ax0;
    var y1 = sy0 + ay0;

    // current position
    //
    var cax0 = radius * Math.cos((ca0+shift1) * Math.PI / 180);
    var cay0 = radius * Math.sin((ca0+shift1) * Math.PI / 180);
    var cx1 = sx0 + cax0;
    var cy1 = sy0 + cay0;

    displayLine(sx0, cx1, sy0, cy1, color1, width1);
    displayLine(sx0, x1, sy0, y1, color2, width2);

    if(show2 === true) {
        //var ax1 = radius * (1 + Math.cos((sa1 - 180) * Math.PI / 180));
        //var ay1 = radius * (1 + Math.sin((sa1 - 180) * Math.PI / 180));
        var ax1 = radius * Math.cos((sa0+(sign*sa1)+shift2) * Math.PI / 180);
        var ay1 = radius * Math.sin((sa0+(sign*sa1)+shift2) * Math.PI / 180);
        var x2 = x1 + ax1;
        var y2 = y1 + ay1;

        var cax1 = radius * Math.cos((ca0+(sign*ca1)+shift2) * Math.PI / 180);
        var cay1 = radius * Math.sin((ca0+(sign*ca1)+shift2) * Math.PI / 180);
        var cx2 = cx1 + cax1;
        var cy2 = cy1 + cay1;

        displayLine(cx1, cx2, cy1, cy2, color3, width1);
        displayLine(x1, x2, y1, y2, color4, width2);
        //console.log("3d_limb.290:        . . . .  LINES:  ",limb, "[ sa0=",sa0, "  ax0=",ax0.toFixed(3),  " ay0=",ay0.toFixed(3), "]  [ sa1=",sa1," ax1=",ax1.toFixed(3),  " ay1=",ay1.toFixed(3)," ]");
    } else {
        //console.log("3d_limb.346:        . . . .  LINES:  ",limb, "[ sa0=",sa0, "  ax0=",ax0.toFixed(3),  " ay0=",ay0.toFixed(3), "]");
    }

    displayLine(0, 0, 0, 0, "yellow", 0);       // KLUDGE: close it off, need to figure out why need this
}




export function displayGridLines() {
	var canvas = INFO.out_canvas;
  if (!canvas) return

    //console.log("draw.187:  GRID LINES  canvas=",canvas,  "  output.w=", canvas.width, "  output.h=",canvas.height);

    var x_lines = 9;
    var y_lines = 9;
    var color = "#ff000040";
    var width = 1;
    var dx = canvas.width / (x_lines + 1);
    var dy = canvas.height / (y_lines + 1);
    var x0 = 0;
    var x1 = canvas.width;
    var y0 = 0;
    var y1 = canvas.height;
    for (var x = 1; x < x_lines + 1; x++) {
        y = x * dy;
        displayLine(x0, x1, y, y, color, width);
    }

    for (var y = 1; y < y_lines + 1; y++) {
        x = y * dx;
        displayLine(x, x, y0, y1, color, width);
    }
}



//////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// display image source name
//
export function displayFilename(img_text) {
	var context = INFO.out_context;
  if (!context) return

	var show_filename = false;
	var width = INFO.image_width;
	var height = INFO.image_height;

	if ((context == null) || (show_filename == false)) 
		return;

	var font_size = (width + height)/70;
	context.font = (font_size).toString()+"px arial";
	context.fillStyle = "yellow";
	context.fillText(img_text, 0, height/30);
	context.stroke();
	//console.log("draw.165:  time=",img_text, " y=", Math.floor(height/30), "  font_size=", font_size);
}



// Displays FULL SCREEN OVERLAY
//      - replaces timerDisplayResult()
//
export function displayNotification() {
	var canvas = INFO.out_canvas;
  if (!canvas) return

	var context = INFO.out_context;
    if (canvas === null) return; 

	var width = canvas.width;
	var height = canvas.height;

	var t0 = Date.now();
	if ((TIMES.timer_stop_display > 0) && (t0 < TIMES.timer_stop_display)) {
		var tsize = (INFO.notify_size == null) ? 35 : INFO.notify_size;
        var msize = tsize * (3 / 4)
		var color = (INFO.notify_color == null) ? "red" : INFO.notify_color;
		var xscale = (tsize/ width);
		var yscale = (tsize / height);
        var xf = 150;
        var yf = 205;
        var yspace = height * 0.03;     // 8
		var char_x = xscale * xf;       // estimate pixel
		var char_y = yscale * yf;       // estimate pixel
        var msg_len = INFO.notify_messages.length;

        var y = (msg_len > 0) ? height * 0.2 : height * 0.4;
        var ctr_x = width * 0.5;
        var tx = ctr_x - (INFO.notify_title.length / 2) * char_x;

        // wd= 360  ht= 270  sz= 30  xscale= 0.083  yscale= 0.111  x= 88  y= 108  char_x= 18.3  tx_len= 10  xf= 220
        // wd= 360  ht= 270  sz= 30  xscale= 0.083  yscale= 0.111  x= 96  y= 108  char_x= 16.7  tx_len= 10  xf= 200  GOOD
        // wd= 360  ht= 270  sz= 40  xscale= 0.111  yscale= 0.148  x= 68  y= 108  char_x= 22.2  tx_len= 10  xf= 200
        // wd= 360  ht= 270  sz= 60  xscale= 0.167  yscale= 0.222  x= 13  y= 108  char_x= 33.3  tx_len= 10  xf= 200
        // wd= 360  ht= 270  sz= 30  xscale= 0.083  yscale= 0.111  x= 94  y= 108  char_x= 17.1  tx_len= 10  xf= 205
        // wd= 360  ht= 270  sz= 35  xscale= 0.097  yscale= 0.130  x= 110  y= 108  char_x= 19.9  tx_len= 7  xf= 205  yf= 205  char_y= 26
        // wd= 360  ht= 270  sz= 35  xscale= 0.097  yscale= 0.130  tx= 110  y= 54  char_x= 19.9  tx_len= 7  xf= 205  yf= 205  char_y= 26.6
        // wd= 360  ht= 270  sz= 40  xscale= 0.111  yscale= 0.148  tx= 31  y= 108  char_x= 22.8  tx_len= 13  xf= 205  yf= 205  char_y= 30.4
        //console.log("time_disp.553:    . . . wd=",width, " ht=",height, " sz=", tsize, " xscale=",xscale.toFixed(3), " yscale=",yscale.toFixed(3), " tx=",parseInt(tx), " y=",parseInt(y), " char_x=",char_x.toFixed(1), " tx_len=",INFO.notify_title.length, " xf=",xf, " yf=",yf, " char_y=",char_y.toFixed(1));

        if(INFO.notify_title.length > 0) {
            context.fontWeight = "bolder";
            context.font = (msize).toString()+"px arial";
            context.fillStyle = color;
            context.fillText(INFO.notify_title, tx, y);
        }

        var xx = width * 0.2;
        for (var i = 0; i < INFO.notify_messages.length; i++) {
            var msg = INFO.notify_messages[i];
            var yy = y + ((i + 1) * (char_y + yspace));
            displayText(color, msize, msg, xx, yy);
        }

        if(INFO.notify_messages.length > 1) {
            //console.log("time_disp.176:  ............. DISPLAY   from=",from,"fsize=",scale,"   msg", INFO.notify_messages[0], "  x=",x, " y=",y, " color=",color);
            context.fillStyle = "#cccccc5c";
            context.fillRect(0, 0, width, height);      // grey background to increase visibility
        }
		context.stroke();
    } else {
        if (TIMES.timer_stop_display > 0) {
            // reset
            INFO.notify_messages = [];
            INFO.notify_size = null;
            INFO.notify_color = null;
            INFO.timer_display = "";
            INFO.ptimer_display = "";
            INFO.notify_title = "";
            TIMES.timer_stop_display = 0;
        }
    }
}


// wakes up and display result for time period
//     - Being REPLACED BY displayNotification()
//
export function timerDisplayResult(from) {
    return
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
  if (!canvas) return

	var width = canvas.width;
	var height = canvas.height;

	var t0 = Date.now();
	var show_perf_time = true;
	if ((show_perf_time == true) && ((INFO.show_results === true) || ((TIMES.timer_stop_display > 0) && (t0 < TIMES.timer_stop_display)))) {
		// show result for a few frames 
		var size = (INFO.notify_size == null) ? 24 : INFO.notify_size;
		var color = (INFO.notify_color == null) ? "yellow" : INFO.notify_color;
		var scale = ((canvas.width + canvas.height) / size);
        var x = 30;
        var y = 100;
        if(INFO.webcam_owidth === 1280) {
            x = x * 3;
            y = y * 3;
        }

		context.font = scale.toString()+"px arial";
		context.lineWidth = "6px";
		context.fontWeight = "700";
		context.fillStyle = color;
		context.strokeStyle = "blue";

        if(INFO.notify_title.length > 0) {
            context.fillText(INFO.notify_title, x, y);
        }

        for (var i = 0; i < INFO.notify_messages.length; i++) {
            var msg = INFO.notify_messages[i];
            var yy = y + ((i + 1) * scale * 1.2);
            context.fillText(msg, x, yy);
        }

        // mute background for contrast
        if(INFO.notify_messages.length > 1) {
            //console.log("time_disp.176:  ............. DISPLAY   from=",from,"fsize=",scale,"   msg", INFO.notify_messages[0], "  x=",x, " y=",y, " color=",color);
            context.fillStyle = "#cccccc88"
            context.fillRect(0, 0, width, height);
        }
		context.stroke();

		//console.log("result.190:   DISPLAY   stop=",TIMES.timer_stop_display, " msec", "     preact=",INFO.ptimer_display, " msec");
		setTimeout(timerDisplayResult, 10);   // 30 FPS
	} else {
        INFO.notify_messages = [];
		INFO.notify_size = null;
		INFO.notify_color = null;
		INFO.timer_display = "";
		INFO.ptimer_display = "";
		INFO.notify_title = "";
		TIMES.timer_stop_display = 0;
	}
}
 


// show the calibration frame (usually 6 feet) to eyeball length accuracy
//
export function displayLengthCalibration(standard_len, color, xmid, bottom) {
	var context = INFO.out_context;
  if (!context) return

	if(INFO.show_calibration_mark) {
		const xleft = xmid - (standard_len / 2)
		const xright = xmid + (standard_len / 2)
		//context.fillStyle = 'red';		// for strokeRect
		//context.strokeRect(xleft, (canvas.height - 5), six_feet, 2);
		context.strokeStyle = color;
		context.strokeRect(xleft, (bottom), standard_len, 2);
		context.strokeRect(xleft, (bottom - standard_len), 1, (standard_len));
		context.strokeRect(xright, (bottom - standard_len), 1, (standard_len));
		//console.log("CALIBRATION LINE: start=", xleft, " len=", six_feet)    // 6ft
	}
}


// display meter calibration bar
//
export function displayCalibrationBar(px, ctr_x, ctr_y) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;

    var x0 = ctr_x - (px / 2);
    var x1 = ctr_x + (px / 2);
    var y0 = ctr_y;
    var y1 = ctr_y;

    var color = "#ff000044";
    var width = 8;
    displayLine(x0, x1, y0, y1, color, width);
}



// show body movement speed in feet per second
//
export function displayBodyFTS(speed, degree) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
	var width = canvas.width;
	var height = canvas.height;

	var show_ftps = true;
	if((canvas === null) || (show_ftps === false))
		return;

    //var text = "FT/S: "+speed.toFixed(2) + "  DGR: "+degree;
    var text = " PX_R="+ (parseInt(STATS.pixel_ratio)) + "-" + parseInt(INFO.ref_femur) + " HT_IN="+ parseInt(INFO.height_inch);
    //var text = "M/S: "+speed.toFixed(2) + "  DGR: "+parseInt(degree) + " PX_R="+ (STATS.pixel_ratio.toFixed(3)) + " FMR="+ parseInt(INFO.ref_femur);
    //var text = "M/S: "+speed.toFixed(2) + "  DGR: "+parseInt(degree) + " FMR="+ parseInt(INFO.ref_femur);
	//context.font = ((width + height)/50).toString()+"px arial";
	context.font = ((width + height)/35).toString()+"px arial";
	context.fillStyle = "red";
	context.fillText(text, (width * 1 / 3)-30, (2 * height/20)+0);
	//context.fillText(text, (width * 3 / 4)-30, (height/15)+5);
}


// show body movement speed in feet per second
//
export function displaySpeedRibbon(color, rwidth, x0, y0, x1, y1) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;

	var show_trail = true;
	if((canvas == null) || (show_trail == false))
		return;

    rwidth = (rwidth === 0) ? 0.1 : rwidth;
	context.lineWidth = rwidth;
	context.strokeStyle = color;
	context.beginPath();
	context.moveTo(x0, y0);
	context.lineTo(x1, y1);		 //context.quadraticCurveTo(x0, y0, x1, y1);
	context.closePath();
	context.stroke();
}


// show the ball touch cnt by the ball
//
export function displayBallTouch(cnt, x, y) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
	var width = canvas.width;
	var height = canvas.height;

	var show_ball_cnt = false;
	if((canvas == null) || (show_ball_cnt == false))
		return;

	context.font = ((width + height)/50).toString()+"px arial";
	context.fillStyle = 'rgba(255,0,0,0.8)'; 
	context.fillText("CHANGE-"+cnt+"    ", x+4, y);
}


// show reps and timer left in this set
//      - adjust display depending if showing timer
//      - rep_cnt could be count up or count down
//      - timer count could go up or down (in seconds)
//
export function displayRepsLeft(rep_cnt, timer_cnt, color) {
	var context = INFO.out_context;
    var wd = null, ht = null, rfsize = null, tfsize = null;
    var rx = null, rx0 = null, rx1 = null, ry = null, tx = null, tx1 = null, ty = null;

	//console.log("displayRepsLeft.233: ======== cnt=",cnt, "  x=",x, " y=",y, " canvas=",canvas);
	var show_reps_left = true;
	if((context == null) || (show_reps_left == false) || (!rep_cnt))
		return;

    var rsingle = (rep_cnt < 10) ? 1 : 0;     // shift right if single digit
    var tsingle = (timer_cnt < 10) ? 1 : 0;     // shift right if single digit
    var bx = 0;     // fixed
    var by = 15;    // fixed
    rx0 = 6;

    if (timer_cnt) {
        timer_cnt = ((timer_cnt < 0) ? 0 : timer_cnt) + "'";
        rfsize = (360 + 270)/ 15 * INFO.scale_font;
        tfsize = (360 + 270)/ 19 * INFO.scale_font;

        rx1 = (rfsize * 0.25) * rsingle;     // shift over if single digit
        rx = rx0 + rx1;
        ry = (rfsize * 0.98) + 6;  //62;    // f=63

        tx1 = (tfsize * 0.15) * tsingle;     // shift over if single digit
        tx = rx0 + (rfsize * 1.24) + tx1;
        ty = ry;

        wd = (rfsize * 1.17 + tx);      //74 @f=63
        ht = rfsize * 0.84       //53 @f=63
    } else {
        rfsize = (360 + 270)/ 10 * INFO.scale_font;

        rx1 = (rfsize * 0.25) * rsingle;     // shift over if single digit
        rx = rx0 + rx1;
        ry = (rfsize * 0.92) + 5;  //62;    // f=63
        if(INFO.webcam_owidth === 1280) {
            rfsize = 160;
            rx = 40;
            ry = 200;
        }

        wd = rfsize * 1.17 + rx;      //74 @f=63
        ht = rfsize * 0.84       //53 @f=63
    } 

    displayBlock("#99999980", bx, by, wd, ht);   // background to improve visibility
    if (true && (timer_cnt)) {
        displayBorderText(color, "red", tfsize, 1, timer_cnt, tx, ty);
    } 
    displayBorderText(color, "red", rfsize, 1, rep_cnt, rx, ry);
    //console.log("displayRepsLeft.885: ======== rep_cnt=",rep_cnt, "  rx=",rx, " ry=",ry, " rfsize=",rfsize, " scale_x=", INFO.scale_x, " scale_y=",INFO.scale_y, " ht=",ht);


        /*
        context.fontWeight = "bolder";
        context.font = (tfsize).toString()+"px arial";
        context.fillStyle = color;
        context.fillText(timer_cnt, tx, ty);

        context.strokeStyle = "red";       //"#666";
        context.lineWidth = "2px";
        context.strokeText(timer_cnt, tx, ty);
        */

    /*
    context.font = (rfsize).toString()+"px arial";
    context.fillStyle = color;
    context.fillText(rep_cnt, rx, ry);

    context.strokeStyle = "red";       //"#666";
    context.lineWidth = "2px";
    context.strokeText(rep_cnt, rx, ry);
    */
    //context.fillStyle = 'rgba(255,255,0,0.8)'; 
    //context.stroke();
}



// show turn cnt next to the player
//
export function displayPoseTurn(cnt, x, y) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
	var width = canvas.width;
	var height = canvas.height;

	var show_pose_cnt = true;
	if((canvas == null) || (show_pose_cnt == false))
		return;

	context.font = ((width + height)/50).toString()+"px arial";
	context.fillStyle = 'rgba(255,255,0,0.8)'; 
	context.fillText("TURN-"+cnt+"    ", x+4, y);
}


// show ball touch per minute
//
export function displayTPM(tpm) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
	var width = canvas.width;
	var height = canvas.height;

	var show_tpm = false;
	if((canvas == null) || (show_tpm == false))
		return;

	//context.strokeStyle = 'rgba(195,174,25,1)';		// 'rgba(195,174,25,0.2)';  // a=0.4
	context.fillStyle = 'red';		// for fillText()
	context.font = ((width + height)/40).toString()+"px arial";
	context.fillText("TPM: "+tpm, (width * 3 / 4)-30, (height/18));
}


// show head facing info
//
export function displayDegrees(index, msg) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
	var width = canvas.width;
	var height = canvas.height;
    var scale = height / 270;
    var step = index * 15 * scale;

	if (canvas == null) { return; }

	//context.strokeStyle = 'rgba(195,174,25,1)';		// 'rgba(195,174,25,0.2)';  // a=0.4
	context.fillStyle = 'red';		// for fillText()
	context.font = ((width + height)/55).toString()+"px arial";
	context.fillText(msg, (width * 1 / 2), (height/20) + step);
}



// show head facing info
//
export function displayFacing(msg) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
	var width = canvas.width;
	var height = canvas.height;

	if (canvas == null) { return; }

	//context.strokeStyle = 'rgba(195,174,25,1)';		// 'rgba(195,174,25,0.2)';  // a=0.4
	context.fillStyle = 'red';		// for fillText()
	context.font = ((width + height)/55).toString()+"px arial";
	context.fillText(msg, (width * 1 / 2)-30, (height/20));
}



// show body has reversed
//
export function displayBodyReverse(dir, x, y) {
	var canvas = INFO.out_canvas;
	var context = INFO.out_context;
	if(canvas == null)
		return;

	var show_reverse = false;
	if(show_reverse == false)
		return;

	var font_size = (canvas.width + canvas.height)/60;
	context.fillStyle = "pink";
	context.fillText("REVERSE-"+dir, x, y);
	context.font = font_size.toString()+"px arial";
	context.stroke();        
}


// NOT USE: show ball extracted from image (NOT WORKING WELL YET)
//
export function displayExtractedBallBox(color, line_width, x0, y0, ww, hh) {
	var context = INFO.out_context;

	var show_extract_ball = false;
	if((context == null) || (show_extract_ball == false))
		return;

    line_width = (line_width === 0) ? 0.1 : line_width;
	context.strokeStyle = color;
	context.lineWidth = line_width;
	//context.strokeRect(x0, y0, ww, hh);
	context.beginPath();       // Start a new path
	context.moveTo(x0, y0+(hh/2));    // Move the pen to (30, 50)
	context.lineTo(x0+ww, y0+(hh/2));  // Draw a line to (150, 100)
	context.moveTo(x0+(ww/2), y0);    // Move the pen to (30, 50)
	context.lineTo(x0+(ww/2), y0+hh);  // Draw a line to (150, 100)
	context.stroke();        
}




// initialize global state for HTML canvas display related
//    - slight delay to give React time to enable the display elements
//
export function initVideoDisplay(canvas_name, from) {
    if (INFO.analysis_canvas === canvas_name) { return };

    setTimeout(() =>{
        var canvas = null;
        var context = null;
        if(canvas_name) {
            canvas = document.getElementById(canvas_name);
            if (canvas) {
                context = canvas.getContext("2d");
                INFO.analysis_canvas = canvas_name;
                INFO.out_canvas = canvas;       // NEED THIS for legacy code
                INFO.out_context = context;     // NEED THIS for legacy code
                console.log("init_a_disp.1050: ****** INIT ANALYZE CANVAS  c.name=", INFO.analysis_canvas, " from=",from, " dev_ai_run=",INFO.dev_ai_running, " recording=",INFO.dev_recording, " I.canvas=", INFO.out_canvas, " I.ctx=",INFO.out_context, " now=", Date.now()%100000/1000);
            } else {
                console.error("init_a_disp.359:  ! ! ! ! ! ! NO CANVAS FOUND!   canvas=",canvas_name, " from=",from);
            }
        } else {
            console.log("init_a_disp.982: !!!!!! INIT ANALYZE CANVAS FAILED - BAD NAME  c.name=", canvas_name, " from=",from, " dev_ai_run=",INFO.dev_ai_running, " recording=",INFO.dev_recording, " I.canvas=", INFO.out_canvas, " I.ctx=",INFO.out_context);
        }
    }, 100);        // slight delay for React to turn on <canvas>
}